import logoIcon from "@/client/assets/brand/ff-icon.png"
import { cn } from "@/lib/utils"

type BrandMarkProps = {
  className?: string
  /** Larger mark for hero / auth surfaces */
  size?: "sm" | "md" | "lg"
  /** Light text on dark backgrounds */
  inverted?: boolean
}

const iconSize = {
  sm: "h-7 w-auto",
  md: "h-8 w-auto",
  lg: "h-10 w-auto",
} as const

const titleSize = {
  sm: "text-sm",
  md: "text-sm",
  lg: "text-base",
} as const

/**
 * Shared FeelyFeely Admin wordmark used in sidebar and auth surfaces.
 */
export function BrandMark({ className, size = "md", inverted = false }: BrandMarkProps) {
  return (
    <span className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <img
        src={logoIcon}
        alt=""
        className={cn("shrink-0 object-contain", iconSize[size])}
      />
      <span
        className={cn(
          "min-w-0 border-l pl-2.5",
          inverted ? "border-white/25" : "border-sidebar-border"
        )}
      >
        <span
          className={cn(
            "block truncate font-bold leading-tight",
            titleSize[size],
            inverted ? "text-white" : "text-blue-950"
          )}
        >
          FeelyFeely
        </span>
        <span
          className={cn(
            "mt-0.5 block truncate text-[10px] font-semibold uppercase tracking-[0.16em]",
            inverted ? "text-white/70" : "text-blue-950/60"
          )}
        >
          Admin
        </span>
      </span>
    </span>
  )
}
